/**
 * DirectionManager
 *
 * Manages all direction icons that need to be drawn on the layer.
 * Includes spatial decluttering to prevent icon overlap.
 */

import { DeclutterManager } from '../spatial'
import type { DirectionIcon } from './types'

export class DirectionManager {
  private icons: DirectionIcon[] = []
  private declutterManager: DeclutterManager

  constructor() {
    this.declutterManager = new DeclutterManager({
      threshold: 0,
    })
  }

  /**
   * Adds a new icon to draw
   */
  add(x: number, y: number, color: string, rotation: number): void {
    this.icons.push({ x, y, color, rotation })
  }

  /**
   * Returns all icons to draw
   */
  getAll(): readonly DirectionIcon[] {
    return this.icons
  }

  /**
   * Returns the number of registered icons
   */
  size(): number {
    return this.icons.length
  }

  /**
   * Clears all registered icons and resets declutter state
   */
  clear(): void {
    this.icons = []
    this.declutterManager.clear()
  }

  /**
   * Returns the internal declutter manager
   * Used by collector to check overlap before adding icons
   */
  getDeclutterManager(): DeclutterManager {
    return this.declutterManager
  }
}
